module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-black-dialog"
  }, [_c('div', {
    staticClass: "m-confirm"
  }, [_c('div', {
    staticClass: "confirm-hd"
  }, [_c('strong', {
    staticClass: "confirm-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "confirm-bd",
    domProps: {
      "innerHTML": _vm._s(_vm.mes)
    }
  }), _vm._v(" "), (typeof _vm.opts == 'function') ? [_c('div', {
    staticClass: "confirm-ft"
  }, [_c('a', {
    staticClass: "confirm-btn default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeConfirm(false)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "confirm-btn primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeConfirm(false, _vm.opts)
      }
    }
  }, [_vm._v("确定")])])] : [_c('div', {
    staticClass: "confirm-ft"
  }, _vm._l((_vm.opts), function(item) {
    return _c('a', {
      staticClass: "confirm-btn",
      class: typeof item.color == 'boolean' ? (item.color ? 'primary' : 'default') : '',
      style: ({
        color: item.color
      }),
      attrs: {
        "href": "javascript:;",
        "data-track": item.track
      },
      on: {
        "click": function($event) {
          _vm.closeConfirm(item.stay, item.callback)
        }
      }
    }, [_vm._v(_vm._s(item.txt))])
  }))]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da80a40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialog/confirm/ConfirmTpl.vue
// module id = 596
// module chunks = 1